import { useState, useEffect } from 'react'

export const useDebounce = <T>(value: T, delay: number): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useEffect((): (() => void) => {
    const debounce = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)
    return (): void => {
      clearTimeout(debounce)
    }
  }, [value, delay])

  return debouncedValue
}
